import React from "react";

type Props = PropsFromLocalize;
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer, Text, View } from "@components";

const HelpPanelEmployeeContacts = (props: Props) => {
  const { t } = props;

  const columns = [
    {
      title: t("ITEM"),
      name: "item",
      width: 110,
      renderItem: item => item.label,
      getCellClassName: item => {
        switch (item.id) {
          case "low":
            return "bg-mint";
          case "medium":
            return "bg-coffee";
          case "high":
            return "bg-rose";
          default:
            return "";
        }
      },
    },
    {
      title: t("DESCRIPTION"),
      name: "details",
      renderItem: item => item.details,
    },
  ];

  const typesData = [
    {
      id: "basic",
      label: t("BASIC"),
      details: t("BASIC_NOTIFICATION_TYPE"),
    },
    {
      id: "standard",
      label: t("STANDARD"),
      details: t("STANDARD_NOTIFICATION_TYPE"),
    },
    {
      id: "full",
      label: t("FULL_NOTIFICATION"),
      details: t("FULL_NOTIFICATION_TYPE"),
    },
  ];

  const exposureData = [
    {
      id: "low",
      label: t("EXPOSURE_INDEX_LOW"),
      details: t("EXPOSURE_LOW_DESCRIPTION"),
    },
    {
      id: "medium",
      label: t("EXPOSURE_INDEX_MEDIUM"),
      details: t("EXPOSURE_MEDIUM_DESCRIPTION"),
    },
    {
      id: "high",
      label: t("EXPOSURE_INDEX_HIGH"),
      details: t("EXPOSURE_HIGH_DESCRIPTION"),
    },
  ];

  const departmentsData = [
    {
      id: "sent-to",
      label: t("SENT_TO"),
      details: t("SENT_TO_DESCRIPTION"),
    },
    {
      id: "received-for",
      label: t("RECEIVED_FOR"),
      details: t("RECEIVED_FOR_DESCRIPTION"),
    },
  ];

  return (
    <View>
      <View margin="0.25rem 0 1rem 0">
        <WistiaPlayer
          videoId={WistiaPlayer.videos.EMPLOYEE_CONTACTS_INSTRUCTIONS}
          title={t("NOTIFICATION_CONTACTS")}
        />
      </View>
      <Text type="h6">{t("NOTIFICATION_TYPES")}</Text>
      <SimpleGrid className="theme-help" columns={columns} rows={typesData} />
      <Text type="h6">{t("DATA_EXPOSURE_INDEX")}</Text>
      <SimpleGrid className="theme-help" columns={columns} rows={exposureData} />
      <Text type="h6">{t("DEPARTMENT_CONTACTS")}</Text>
      <SimpleGrid className="theme-help" columns={columns} rows={departmentsData} />
    </View>
  );
};

export default localize()(HelpPanelEmployeeContacts);
